<script>
    import { onDestroy, onMount } from "svelte";
    import { get } from "svelte/store";

    import AviationAlertsStore from "./AviationAlertsStore";
    import AlertTypeFilterSwitch from "../UI/AlertFilters/AlertTypeFilterSwitch.svelte";
    import MenuItem from "../UI/FlyoutMenu/MenuItem.svelte";
    import MapStore from "../Map/Store";
    import AlertsStore from "../Alerts/Store";
    import AircraftResultsTable from "./AircraftResultsTable.svelte";

    import "../UI/AlertList/AlertList.scss";
import AircraftProperty from "../Models/Enums/AircraftProperty";
import User from "../Branding/User";
import Feature from "../Branding/Feature";
import Router from "../Router";
import AviationKeyComponent from "../UI/Key/AviationKeyComponent.svelte";
import AuthStore from "../Auth/Store";

    let easAlertData = AviationAlertsStore.filters.eas; // AlertsStore.generators.filterType();
    let easAlertVisible = easAlertData.visible;

    // onMainToggle={layerChange} 
    // onSubToggle={sublayerChange
    
    onMount(() => {
		AviationAlertsStore.actions.initMap(MapStore.helpers.getMap());
		AviationAlertsStore.actions.initData();       

        let cachedIconMode = null;
		AviationAlertsStore.iconMode.subscribe((iconMode) => {
			if (AuthStore.helpers.isLoggedIn()) {
				if (iconMode !== cachedIconMode) {
					cachedIconMode = iconMode;
					const liveVessels = get(AviationAlertsStore.results.aircraftGroup.vessels);
					if (liveVessels) {
						liveVessels.forEach(vessel => vessel.setIconMode(cachedIconMode));
						AviationAlertsStore.actions.updateMapSources();
					}
				}
			}
		});

    });
    onDestroy(()=>{
        AviationAlertsStore.actions.deinitMap();
    });

    let aircraft = AviationAlertsStore.results.aircraftGroup.vessels;
    let lastUpdated = AviationAlertsStore.results.aircraftGroup.lastUpdated;
    let aircraftSelected = AviationAlertsStore.results.aircraftGroup.selected[AircraftProperty.ICAO_ADDRESS];
    $: {
        $aircraft;
        $lastUpdated;
        $easAlertVisible;

        if ($aircraft.length > 0) {
			// easAlertData.exists.set(AlertsStore.helpers.hasAlertType("EAS", $aircraft));
			easAlertData.exists.set($aircraft.length > 0);
        }

        AviationAlertsStore.actions.updateMapSources();
    }

    let gotoAircraftHistory = () => {
        let icaoAddresses = $aircraftSelected;
		Router.actions.gotoAircraftHistoryForICAOAddresses(icaoAddresses);
    };

</script>

<MenuItem materialIcon={"layers"} title={"Alert Filters"} class="layer-list-component filters-component">

    <AlertTypeFilterSwitch alertType={"EAS"} filterData={easAlertData} />

</MenuItem>

<MenuItem title={"Current Alerts"} materialIcon={"flight"}
		  class="query-component alert-list-component">
    <AircraftResultsTable aircrafts={AviationAlertsStore.results.aircraft} aircraftGroup={AviationAlertsStore.results.aircraftGroup} height={"350px"} />
    
    {#if $aircraftSelected.length >= 1 && User.hasFeature(Feature.AVIATION.AIRCRAFT_HISTORY.VIEW)}
        <div><button class='btn-alertlist-vesselhistory bg-secondary' on:click={gotoAircraftHistory}>Check Aircraft History ({$aircraftSelected.length} selected)</button></div>
    {/if}
    
    <button class='btn-clear bg-error' on:click={()=>{ 
        AviationAlertsStore.results.aircraftGroup.deselectAll();
		AviationAlertsStore.results.aircraftGroup.update();
    }}>Clear Selection</button>
    <!-- {#if tableSortBy !== "selected" && $aircraftSelected.length > 0}
        <button class='btn-selectall bg-info' on:click={sortBySelected}>Sort By Selected</button>
    {/if} -->
    <!-- <button class='btn-selectall bg-primary' on:click={()=>{
        AlertsStore.vesselGroup.deselectAll();
        AlertsStore.vesselGroup.update();
    }}>Select All</button> -->
</MenuItem>

<AviationKeyComponent />